import { QueryParamNames } from '../models/QueryParamNames'
import { NotificationEntry, NotificationInfoModifiedEntityEnum } from '../sdk'

export function getUrl(notification: NotificationEntry, isDvi?: boolean) {
  switch (notification.info!.modifiedEntity) {
    case NotificationInfoModifiedEntityEnum.RepairOrder: {
      if (isDvi) {
        return '/dvi/jobs' + '/' + notification.info!.modifiedEntityId!
      }
      return '/estimates' + '/' + notification.info!.modifiedEntityId!
    }
    case NotificationInfoModifiedEntityEnum.Inspection: {
      if (isDvi) {
        return '/dvi/inspections' + '/' + notification.info!.modifiedEntityId!
      }
      return '/inspections' + '/' + notification.info!.modifiedEntityId!
    }
    case NotificationInfoModifiedEntityEnum.RepairOrderMessage: {
      if (isDvi) {
        return '/dvi/jobs' + '/' + notification.info!.modifiedEntityId!
      }
      return '/estimates' + '/' + notification.info!.modifiedEntityId!
    }
    case NotificationInfoModifiedEntityEnum.CustomerMessage: {
      return '/customers' + '/' + notification.info!.modifiedEntityId!
    }
    case NotificationInfoModifiedEntityEnum.IntakeRequest: {
      const params = new URLSearchParams({
        [QueryParamNames.INTAKE_REQUEST_ID]:
          notification.info!.modifiedEntityId!,
        [QueryParamNames.IS_REPAIR_ORDER]: 'true'
      })
      return `/estimates/new?${params.toString()}`
    }
    case NotificationInfoModifiedEntityEnum.AppointmentScheduleRequest: {
      return '/appointments' + '/' + notification.info!.modifiedEntityId!
    }
    default: {
      throw new Error('Function not implemented.')
    }
  }
}
